import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import createRootReducers from "reducers";
import createSagaMiddleware from "redux-saga";
import { applyMiddleware, createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootSaga from "sagas";

export const history = createBrowserHistory();
const rootReducer = createRootReducers(history);
const router = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();
const enhancer = composeWithDevTools(applyMiddleware(router, sagaMiddleware));

export function configureStore(initialState?: sage.state.IRedux): Store {
    const store = createStore(rootReducer, initialState, enhancer);
    sagaMiddleware.run(rootSaga);
    return store;
}
